import { defineMessages, useIntl } from "react-intl"
import { Stage } from "src/components"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { TechnicalData } from "./components/TechnicalData"
import { TechnicalDataSkeleton } from "./components/TechnicalDataSkeleton"
import { useTechnicalData } from "./hooks/useTechnicalData"

const messages = defineMessages({
	title: {
		defaultMessage: "Technical Data",
		id: "vehicleDetails.overview.technicaldata.title",
	},
})

export const TechnicalDataContainer = withErrorHandler(() => {
	const technicalData = useTechnicalData()
	const { formatMessage } = useIntl()
	return (
		<Stage title={formatMessage(messages.title)}>
			<ErrorNotificationInline dismissButton={false} />
			{technicalData ? (
				<TechnicalData view={technicalData} />
			) : technicalData === undefined ? (
				<TechnicalDataSkeleton />
			) : null}
		</Stage>
	)
})
